<template>
  <b-card>
    <create-client
      class="mt-2 pt-75"
    />
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import CreateClient from './CreateClient.vue'

export default {
  components: {
    BCard,
    CreateClient,
  },
}
</script>
